import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment, setCsmsAppConfig } from '@kempower-nx-workspace/receipt-lookup-environment';

// push the environment config for app authentication and api access
setCsmsAppConfig(environment.appConfig);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
